import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Banknote } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function PartnerPayoutsPanel() {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/activity-payouts").then((r) => setRows(r.data.payouts)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  const pay = async (id) => {
    try { await api.post(`/admin/activity-payouts/${id}/payout`); toast.success(t("payouts.paidToast")); load(); }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  return (
    <div data-testid="payouts-panel" className="space-y-3">
      <p className="text-sm text-muted2 font-body">{t("payouts.desc")}</p>
      {rows.length === 0 ? (
        <p data-testid="payouts-empty" className="text-muted2 font-body text-center py-10 bg-white rounded-2xl border border-border">{t("payouts.empty")}</p>
      ) : rows.map((r) => (
        <div key={r.id} data-testid={`payout-${r.id}`} className="bg-white rounded-2xl border border-border p-5 flex items-center justify-between gap-3">
          <div>
            <p className="font-heading font-bold text-ink">{r.activity_name}</p>
            <p className="text-sm text-muted2 mt-1">{t("payouts.partner")}: {r.partner_name || "—"} · {r.partner_email}</p>
            <p className="text-sm mt-1"><span className="text-muted2">{t("payouts.net")}:</span> <span className="font-bold text-canard-dark">{r.net} €</span> {!r.partner_connected && <span className="text-xs text-orange-600 font-semibold">· {t("payouts.notConnected")}</span>}</p>
          </div>
          <Button size="sm" data-testid={`payout-btn-${r.id}`} onClick={() => pay(r.id)} className="rounded-full bg-emeraude hover:bg-emeraude-dark font-bold h-9 shrink-0"><Banknote className="w-4 h-4 mr-1" /> {t("payouts.pay")}</Button>
        </div>
      ))}
    </div>
  );
}
